import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import { PaymentTypeEnum } from '@bo-client/shared/constants/enums';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-economic-data',
  templateUrl: './economic-data.component.html',
  styleUrls: ['./economic-data.component.scss']
})
export class EconomicDataComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() error: boolean;
  @Input() canUpdate = false;

  public paymentTypeEnum = PaymentTypeEnum;
  public isTHN = false;

  get sepaActivated() {
    return this.dataShareService.tenantConfig.feederContract?.sepaActivated;
  }

  constructor(private createFormsService: CreateFormsService, private dataShareService: DataShareService) {}

  ngOnInit(): void {
    this.isTHN = true;
    if (this.isTHN) {
      this.inputForm.get('paymentType').patchValue(PaymentTypeEnum.BANKTRANSFER);
      this.inputForm.get('sepaMandate').get('acceptedSepa').clearValidators();
      this.inputForm.get('sepaMandate').get('acceptedSepa').patchValue(null);
      this.inputForm.get('sepaMandate').get('acceptedSepa').markAsTouched();
    }
    if ((this.inputForm.get('invoiceContact') as FormArray).controls[0].get('mail').value) {
    } else {
      (this.inputForm.get('invoiceContact') as FormArray).removeAt(0);
    }
  }

  changePaymentType(event: any) {
    if (event.value == this.paymentTypeEnum.DIRECTDEBIT) {
      this.inputForm
        .get('sepaMandate')
        .get('acceptedSepa')
        .setValidators([Validators.required, this.createFormsService.mustTrue]);
      this.inputForm.get('sepaMandate').get('acceptedSepa').markAsTouched();
    } else {
      this.inputForm.get('sepaMandate').get('acceptedSepa').clearValidators();
      this.inputForm.get('sepaMandate').get('acceptedSepa').patchValue(null);
      this.inputForm.get('sepaMandate').get('acceptedSepa').markAsTouched();
    }
    this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(null);
  }

  changeDifferentInvoiceAddress(event: any) {
    if (event.checked) {
      const newItem: FormGroup = this.createFormsService.createContactDataForm({});
      (this.inputForm.get('invoiceContact') as FormArray).push(newItem);
      this.inputForm.get('hasDifferentInvoiceContact').patchValue(true);
    } else {
      (this.inputForm.get('invoiceContact') as FormArray).removeAt(0);
      this.inputForm.get('hasDifferentInvoiceContact').patchValue(false);
    }
  }

  changeSepaConditions(event) {
    if (event) {
      this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(new Date());
    } else {
      this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(null);
    }
  }
}
